<template>
    <v-card class="app-screen-bg pl-2 pl-md-10 pokedex-page">
        <div class="pokedex-page__scroll" v-if="pokedex && pokemons">
            <div class="pokedex-page__sticky-header">
                <div class="pokedex-title-pill-wrap">
                    <span class="pokedex-title-pill">{{ $t('pokedex.pokedex.titlePill', {collected: pokedex.length, total: pokemons ? pokemons.length : 0}) }}</span>
                </div>
              <div class="pokedex-title-pill-wrap">
                <div class="pokedex-toolbar btn-shadow">
                    <v-btn
                        v-if="generation !== 1"
                        text
                        :loading="loading"
                        @click="generation = 1"
                    >
                        {{ $t('pokedex.pokedex.gen1Button') }}
                    </v-btn>
                    <v-btn
                        v-if="generation !== 2"
                        text
                        :loading="loading"
                        @click="generation = 2"
                    >
                        {{ $t('pokedex.pokedex.fakemonsButton') }}
                    </v-btn>
                </div>
            </div>
                <div class="pokedex-type-filter-bar">
                    <v-chip
                        small
                        outlined
                        :color="$vuetify.theme.dark ? 'white' : undefined"
                        class="pokedex-type-filter-toggle"
                        @click="filtersOpen = !filtersOpen"
                    >
                        <v-icon size="15" left>mdi-filter-variant</v-icon>
                        {{ $t('pokedex.pokedex.filterToggleLabel') }}<template v-if="selectedTypes.length"> ({{ selectedTypes.length }})</template>
                        <v-icon size="15" right>{{ filtersOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-chip>
                    <v-expand-transition>
                        <div v-if="filtersOpen" class="pokedex-type-filter-panel">
                            <v-chip-group v-model="selectedTypes" multiple column>
                                <v-chip
                                    v-for="typeId in typeIds"
                                    :key="typeId"
                                    :value="typeId"
                                    :style="typeChipStyle(typeId)"
                                    small
                                    active-class="pokedex-type-filter-chip--active"
                                >
                                    {{ typeId }}
                                </v-chip>
                            </v-chip-group>
                        </div>
                    </v-expand-transition>
                </div>
            </div>

            <div class="pokedex-grid" v-if="filteredPokemons && filteredPokemons.length">
                <PokedexCard
                    v-for="pokemon in filteredPokemons"
                    :key="pokemon.id"
                    :pokemon-type="pokemon"
                    :unknown="know(pokemon.number)"
                    :owned-count="ownedCounts[pokemon.number] || 0"
                    :stolen-count="stolenCounts[pokemon.number] || 0"
                    :ever-caught="everCaught(pokemon.number)"
                    @open-skills="openSkills(pokemon)"
                />
            </div>
            <p v-else-if="selectedTypes.length" class="pokedex-empty-filter">{{ $t('pokedex.pokedex.noPokemonMatchesFilter') }}</p>
        </div>

        <SkillPopup v-model="skillDialogOpen" :pokemon-type="selectedPokemon"/>
    </v-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import PokedexCard from "@/components/pokedex/PokedexCard";
    import SkillPopup from "@/components/pokedex/SkillPopup";
    import {API_ENTRYPOINT} from "@/config/entrypoint";
    import {TYPE_COLORS, typeChipStyle} from '@/utils/typeColorEnum';

    export default {
        components: {PokedexCard, SkillPopup},
        data() {
            return {
                pokemons: null,
                pokedex: [],
                catchedTypes: [],
                ownedCounts: {},
                stolenCounts: {},
                generation: 1,
                selectedTypes: [],
                filtersOpen: false,
                loading: false,
                selectedPokemon: null,
                skillDialogOpen: false,
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item'
            }),
            typeIds() {
                return Object.keys(TYPE_COLORS);
            },
            filteredPokemons() {
                if (!this.selectedTypes.length) {
                    return this.pokemons;
                }
                return this.pokemons.filter((p) => this.selectedTypes.includes(p.type.id));
            },
        },
        watch: {
            user () {
                 this.loadData();
            },
            generation () {
                 this.loadData();
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            ...mapActions({
                fetchObject: 'pokemon/fetchObject',
            }),
            typeChipStyle,
            loadData() {
                if (this.user !== undefined)
                {
                    this.loading = true
                    let url = new URL("api/pokedex/"+this.user.id, API_ENTRYPOINT);
                    let obj = {url: url, method:'GET'};
                    this.fetchObject(obj).then(
                        (data) => {
                            this.pokedex = this.generation === 1 ? data.pokedex : data.pokedexAlola;
                            this.catchedTypes = this.generation === 1 ? data.catchedTypesGen1 : data.catchedTypesAlola;
                            this.ownedCounts = data.ownedPokemonCounts || {};
                            this.stolenCounts = data.stolenPokemonCounts || {};
                            let urlString = "/api/pokemon_types?page=1";
                            url = new URL(urlString, API_ENTRYPOINT);
                            url.searchParams.set("itemsPerPage", 300);
                            url.searchParams.set("generation",this.generation);
                            obj = {url: url, method:'GET'}
                            this.fetchObject(obj).then(
                                (data) => {
                                    this.pokemons = data['member'];
                                    this.loading = false;
                                }
                            );
                        }
                    );

                }
            },
            know(number){
                return !this.pokedex.includes(number.toString());
            },
            everCaught(number){
                return (this.catchedTypes || []).includes(number.toString());
            },
            openSkills(pokemon) {
                this.selectedPokemon = pokemon;
                this.skillDialogOpen = true;
            },
        },
    }
</script>

<style scoped>
    .pokedex-page {
        /* ne 100vh - viz komentar u ".new-shell-ui .v-main" v App.vue */
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .pokedex-page__scroll {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding-right: 8px;
    }

    /* Sticky primo uvnitr scrollovaci oblasti, vzor Toplist.vue - viz
       claude/architecture/frontend.md bod 8 a claude/components/pokedex.md. */
    .pokedex-page__sticky-header {
        position: sticky;
        top: 0;
        z-index: 3;
        padding-bottom: 4px;
    }

    .pokedex-title-pill-wrap {
        display: flex;
        justify-content: center;
        padding: 8px 0;
    }

    .pokedex-title-pill {
        display: inline-block;
        background: rgba(0, 0, 0, 1);
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        padding: 6px 20px;
        border-radius: 20px;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, .6);
    }

    .pokedex-toolbar {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
        padding: 2px 14px;
        border-radius: 20px;
    }

    /* Sdileny .btn-shadow stin (stejny jako Base move tlacitko) - viz
       claude/components/pokedex.md. */
    .theme--light .pokedex-toolbar {
        background: rgba(255, 255, 255, 0.65);
    }
    .theme--dark .pokedex-toolbar {
        background: rgba(100, 100, 100, 0.7);
    }

    /* Stejny vzor jako .skill-picker-filter-bar/toggle/panel v
       SkillPickerDialog.vue - typova rada schovana za tlacitkem "Filtr",
       viz claude/components/pokedex.md. */
    .pokedex-type-filter-bar {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 8px 8px;
    }

    .pokedex-type-filter-toggle {
        cursor: pointer;
    }

    .pokedex-type-filter-panel {
        width: 100%;
        margin-top: 8px;
        padding: 8px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.25);
    }

    /* Stejna konvence jako .skill-picker-chip--active v SkillPickerDialog.vue -
       jen orameckovani, ne prebiti barvy typu. */
    ::v-deep .pokedex-type-filter-chip--active {
        border: 2px solid #FB8C00 !important;
    }

    .pokedex-empty-filter {
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        opacity: 0.75;
        padding-top: 24px;
    }

    .pokedex-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(min(150px, calc(33.333% - 12px)), 1fr));
        gap: 12px;
        align-items: stretch;
        padding: 4px 4px 16px;
    }
</style>
